import LemonTeaFont from "pages/flyer/builder/fonts/lemonTea";

const fonts: Record<string, string> = { "Lemon Tea": LemonTeaFont };

export default fonts;
